import { BibliographyClass, CollectionFlag, Prefix } from '@/types'
import { defaultSystemCode, exists, SystemCode } from '@/api'

export interface BibliographyIsbn {
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  marcNo: string
  marcType: string
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  displayPublished: string
  displayClass: string
  collectionFlag: CollectionFlag
  isbn10: string
  isbn13: string
}

export function BibliographyIsbnFromJSON(json: any): BibliographyIsbn {
  return {
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    marcNo: exists(json, 'marc_no') ? json.marc_no : '',
    marcType: exists(json, 'marc_type') ? json.marc_type : '',
    searchType: exists(json, 'search_type')
      ? Object.assign(defaultSystemCode(), { code: json.search_type })
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    displayPublished: exists(json, 'display_published')
      ? json.display_published
      : '',
    displayClass: exists(json, 'display_class') ? json.display_class : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    isbn10: exists(json, 'isbn10') ? json.isbn10 : '',
    isbn13: exists(json, 'isbn13') ? json.isbn13 : ''
  }
}
